import React from 'react';
import { RequestFilesList } from '../common/RequestFilesList.js';

/** Formats a stored date without allowing UTC conversion to change its day. */
function formatDate(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ''));
    if (!match) return String(value || 'Unknown');
    const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
}

/** Formats a stored local date/time answer for the browser locale. */
function formatDateTime(value) {
    const date = new Date(String(value || ''));
    if (Number.isNaN(date.getTime())) return String(value || 'Unknown');
    return date.toLocaleString('en-GB', {
        day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit',
    });
}

/** Renders one stored Forms answer consistently in admin and user response views. */
export default function FormResponseAnswerValue({ answer, submissionId }) {
    const value = answer?.value;
    const answerType = String(answer?.type || '').toUpperCase();
    if (['FILE', 'IMAGE_MARKUP'].includes(answerType)) {
        return <RequestFilesList
            files={Array.isArray(value) ? value : []}
            folder="forms"
            itemId={submissionId}
            emptyText="No files supplied"
            showTitle={false}
            groupKey={String(answer?.questionId || 'form-answer')}
        />;
    }
    if (answerType === 'DATE') return formatDate(value);
    if (answerType === 'DATETIME') return formatDateTime(value);
    if (answerType === 'TIME') return String(value || '').slice(0, 5) || 'No answer supplied';
    if (answerType === 'APPROVAL') {
        if (value === 'approved') return answer?.approvalSettings?.confirmLabel || 'Approved';
        if (value === 'denied') return answer?.approvalSettings?.denyLabel || 'Denied';
    }
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    return String(value ?? '').trim() || 'No answer supplied';
}
